import React from 'react';
import { ClipLoader } from 'react-spinners';
import { css, keyframes } from '@emotion/react';

const clip = keyframes`
  0% {transform: rotate(0deg) scale(1)}
  50% {transform: rotate(180deg) scale(1)}
  100% {transform: rotate(360deg) scale(1)}
`;

export default function CircularProgress({ color = '#1AEEC2', style, ...props }) {
  const className = css`
    ${style};
     {
      animation: ${clip} 0.75s 0s infinite linear;
    }
  `;

  return <ClipLoader css={className} color={color} {...props} />;
}
